
import Header from "../Header";
import Footer from "../Footer";
import { Container } from "@mui/material";
const MainLayout = ({ children }) => {
  return (
    <>
      <Header />
      <Container className="w100">
      <main style={{ minHeight: "80vh"}} className="headerSpacing">{children}</main>
      
      </Container>
      <Footer />
      </>
  );
};

export default MainLayout;




// import Header from "../Header";
// import Footer from "../Footer";
// import { useNavigate, Outlet } from 'react-router-dom';
// import { Box, Grid } from '@mui/material';
// const MainLayout = ({ children }) => {
//   return (
//     <>
//       <Header />
//       <Box sx={{ display: 'flex', mt: '74px', mb: '50px' }}>
//         {/* <Sidebar /> */}
//         {/* <Box sx={{ flexGrow: 1, px: { xs: 2, sm: 3, md: 5 }, py: 3 }}> */}
//         <div style={{ minHeight: "80vh", padding: "20px" }}>
//           <Outlet />
//           </div>
//         {/* </Box> */}
//       </Box>
//       <Footer />
//     </>
//   );
// };

// export default MainLayout;

